import { render, staticRenderFns } from "./uploadModal.vue?vue&type=template&id=37519ad0&scoped=true"
import script from "./uploadModal.vue?vue&type=script&lang=js"
export * from "./uploadModal.vue?vue&type=script&lang=js"
import style0 from "./uploadModal.vue?vue&type=style&index=0&id=37519ad0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37519ad0",
  null
  
)

export default component.exports